import script from "./UpdatePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePrompt.vue?vue&type=style&index=0&id=5ffef7ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffef7ea"]])

export default __exports__